import Call from '../Call';

const AdkHourFactor = {
    get() {
        return Call(`adkHourFactor`);
    },

    save(factors) {
        return Call('adkHourFactor','POST', { factors });
    }
};

export default AdkHourFactor;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkHourFactor.js